import type { ICellRendererComp, ICellRendererParams } from "ag-grid-enterprise";

/**
 * StatusCellRenderer
 *
 * Renders the voter status cell using pre-built HTML from the server
 * (`status_html` on the row data), which preserves the styled output
 * from HtmlStatusPresenter — e.g. green "Voted" text + italic date line.
 *
 * Falls back to the plain `value` string if no HTML is available.
 */
export class StatusCellRenderer implements ICellRendererComp {
  private eGui!: HTMLElement;

  init(params: ICellRendererParams): void {
    this.eGui = document.createElement("div");

    // Group rows have no leaf data — render the group key as plain text
    if (params.node.group) {
      this.eGui.textContent = params.value ?? "";
      return;
    }

    this.eGui.className = "ag-status-cell";

    const html = (params.data as Record<string, string>)?.status_html;
    if (html) {
      // Collapse whitespace-only text nodes between tags to prevent blank lines
      // between the status span and the metadata date line.
      this.eGui.innerHTML = html.replace(/>\s+</g, "><").trim();
    } else {
      this.eGui.textContent = params.value ?? "";
    }
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  // Return false — status_html is static per row, no need to refresh in-place
  refresh(): boolean {
    return false;
  }
}
